/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
// Styles
import "../Study/Study.scss";
import "../../sass/slick.scss";
// Assets
import icon_label from "../../assets/icons/icon-label.svg";

// Components
import Subnav from "../../components/Subnav/Subnav";
import Searchbar from "../../components/Searchbar/Searchbar";
import LessonItem from "../../components/LessonItem/LessonItem";
import Banner from "../../components/Banner/Banner";
import { useLessonContext } from "../../context/providers/LessonContext";
import Loader from "react-loader-spinner";
import { useFavoriteContext } from "../../context/providers/FavoriteContext";
import { showErrorMessage, showSuccessMessage } from "../../utils/notification";
import InfiniteScroll from "react-infinite-scroll-component";
import { GET_NEXT_PRONUNCIATIONS } from "../../context/actions/lesson";
export default function Pronunciations(props) {
	const { getPronunciations, pronunciations, loading, countLessons, tipsTotal, lessonTotal, pronunciationFilter, getFollowingLessons } = useLessonContext();
	const [options, setOptions] = React.useState({
		page: 1,
		limit: 5,
	});

	const [hasMore, setHasMore] = React.useState(true);
	//console.log(options);
	const handleNextFetch = () => {
		if (pronunciations.totalDocs < pronunciations.docs.length) {
		console.log(`hasMore` ,hasMore)
			setHasMore(false);
		} else {
			setOptions({
				page: pronunciations.nextPage,
				limit: options.limit,
			});
			//console.log(options);
			let params = {
				page: pronunciations.nextPage,
				limit: 5,
			};
			console.log(params);
			return getFollowingLessons(params, GET_NEXT_PRONUNCIATIONS, "Pronunciation");
		}
	};
	const { success: favoriteSuccess, error: favoriteError, clearNotification } = useFavoriteContext();

	React.useEffect(() => {
		if (pronunciations == null) {
			countLessons();
			getPronunciations(options);
		}

		if (favoriteError !== null) {
			showErrorMessage(favoriteError);
			clearNotification();
		}
		if (favoriteSuccess !== null) {
			showSuccessMessage(favoriteSuccess);
			clearNotification();
		}
	}, [favoriteError, favoriteSuccess]);

	return (
		<div className="container container--main d-xl-flex">
			<div className="order-last ml-xl-5">
				<Banner className="mb-5 d-none d-md-block" {...props}></Banner>
				<div className="d-none d-xl-block">
					<div className="subnav__item subnav__item--noborder subnav__item--large shadow--default d-block">
						<div>
							<div className="d-flex justify-content-between mb-3">
								<div className="subnav__item-label d-flex align-items-center fw--600 color--primary">
									<div>
										<img src={icon_label} alt="Label icon" className="mr-2" />
									</div>
									Course
								</div>
								<div className="subnav__item-label fw--500">
									{pronunciations !== null ? `${pronunciations.totalDocs} materials` : "loading"}{" "}
								</div>
							</div>
							<div className="d-flex justify-content-between">
								<div className="subnav__item-title">Pronunciations</div>
								{/*<div className="subnav__item-badge d-inline-block">32 new</div>*/}
							</div>
						</div>
						<p className="subnav__item-desc fz--16 position-relative mt-3 pt-3">
							In this lesson, we will learn about listening and comprehension of the american accent, as well as
							homophones.{" "}
						</p>
					</div>
					<h3 className="fz--20 mt-5">Other courses</h3>
					<div className="d-flex mt-3">
						<Subnav
							item={{
								name: "Lessons",
								amountVideo: lessonTotal !== null && lessonTotal,
								path: "/lessons",
							}}
						/>
						<Subnav
							item={{
								name: "Astuces",
								amountVideo: tipsTotal !== null && tipsTotal,
								path: "/tips",
							}}
						/>
					</div>
				</div>
			</div>
			<div className="container--content">
				<Searchbar searchPronunciation={true}></Searchbar>
				<div className="filters filters--light d-flex align-items-center mt-4 mt-md-5">
					{/*<button className="filters__item container--default fw--700 flex-auto active">Curriculum</button>
					<button className="filters__item container--default fw--700 flex-auto">Completed</button>*/}
					<span className="fz--16 fw--500 ml-auto d-none d-md-block">
						{pronunciations !== null ? (
							<>{pronunciationFilter !== null ? pronunciationFilter.length : pronunciations.docs.length} materials</>
						) : (
							"loading"
						)}{" "}
					</span>
				</div>
				{loading && (
					<div
						className="input__field mt-3 w-100 mt-md-4"
						style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
					>
						<Loader type="TailSpin" color="#3326ae" height={50} width={50} style={{ marginTop: "3%" }} />
						<p className="input__label mt-3" style={{ marginLeft: "15px" }}>
							Loading 
						</p>
					</div>
				)}
				{pronunciations !== null && pronunciations.docs.length > 0 && (
					<InfiniteScroll
						dataLength={pronunciations.docs.length}
						next={handleNextFetch}
						hasMore={pronunciations.totalDocs <= pronunciations.docs.length ? false : hasMore}
						loader={
							<p className="text-center mt-3">
								<b>{pronunciationFilter !== null ? "" : "Loading"}</b>
							</p>
						}
						initialScrollY={10}
						height={615}
					>
						<div className="container--default mt-4">
							{pronunciationFilter !== null ? (
								<>
									{pronunciationFilter.map((item, index) => (
										<LessonItem item={item} key={index}></LessonItem>
									))}
								</>
							) : (
								<>
									{pronunciations.docs.map((item, index) => (
										<LessonItem item={item} key={index}></LessonItem>
									))}
								</>
							)}
						</div>
					</InfiniteScroll>
				)}
			</div>
		</div>
	);
}
